import React, {FC, ReactElement} from 'react';
import {ActivityViewProps} from "./Exercise";
import {Col, Row} from "antd";
import {StudentsCompletedActivityCard} from "../components/StudentsCompletedActivityCard";
import {GUTTER} from "../../../constants";

export const Reading: FC<ActivityViewProps> = ({activity}): ReactElement => {
    return (
        <Row gutter={GUTTER} style={{marginTop: GUTTER[0]}}>
            <Col xs={24} xl={24}>
                <StudentsCompletedActivityCard activityId={activity.id.toString()}/>
            </Col>
        </Row>
    );
};